/*
*###############################################################################
*Module Name                   : CreditNoteContent.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Friday, june 10th 2022, 1:16:56 pm           #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState } from "react"
import {
  CardText,
  Col,
  Row,
  Alert,
  Button,
  Label,
} from "reactstrap"
//Import Framework components
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPDropDown from "framework/components/DPDropDown"

const CreditNoteContent = ({
  menuCode,
  Gen_DataSearch,

  AlertColor,
  AlertMsg,
  Gen_Code,
  Gen_Code_OnChange,
  Gen_Code_onBlur,

  Gen_Customer_OnChange,
  Gen_Customer_onBlur,
  Gen_Customer_Enabled,

  SearchGetSelectRowCustomer,

  Gen_TxnDate,
  Gen_TxnDate_OnChange,
  Gen_TxnDate_Enabled,
  Gen_Remark1,
  Gen_Remark1_OnChange,
  Gen_Remark1_Enabled,

  Gen_Location_OnChange,
  Gen_Location_Enabled,

  SearchModelOpen,

  menuName,

  SearchGetSelectRow1,
  Gen_Vendor_OnChange,
  Gen_Vendor_Enabled,

  Gen_Collector_OnChange,

  dispCustomer,
  dispSupplier,
  dispSalesExec,
  tog_xlarge_supplier,
  model_xlarge_supplier,
  tog_xlarge_customer,
  model_xlarge_customer,
  tog_xlarge_saleExec,
  model_xlarge_saleExec,
  tog_xlarge_location,
  model_xlarge_location,
  SearchGetSelectRowSupplier,
  SearchGetSelectRowSalesExec,
  SearchGetSelectRowLocation,
  strLocationName,
  strLocation,
  strSalesExecName,
  strSalesExec,
  strSupplierName,
  strSupplier,
  strCustomerName,
  strCustomer,
  strMode,
  strModeName,
  dispMode,
  model_xlarge_mode,
  tog_xlarge_mode,
  GetSelectRowMode,
  Gen_LoadInvoices,
  AutoAllocate,
  TotalPayValue,
  Type,
  Disabled,
  disableTransBTN,
  advancePayment,
  Gen_Mod_Enabled,
  Gen_SaAssis_Enabled,
  PY_SUP_DISPLAY,
  PY_CUS_DISPLAY,
  PY_SA_DISPLAY,
  PY_SUP_SEARCH,
  PY_CUS_SEARCH,
  PY_SA_SEARCH,
  ProcessDisable,
  ReasonTypes,
  strRemarks2,
  RemarksOnchange,
  LocationCode
}) => {

  const ApiURL = window.Links.ApiURL
  const [groupFilter, SetGroupFilter] = useState("a")


  const defaultSortedCus = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              <Col sm={12} md={6} className="mb-4-sm">
                <Row>

                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      Document No
                    </Label>
                  </Col>

                  <Col sm={12} md={8} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={Gen_Code}
                      onChange={Gen_Code_OnChange}
                      disabled={Disabled}
                      onBlur={Gen_Code_onBlur}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_DataSearch}
                      color="success"
                      className="btn-sm"
                      disabled={Disabled}
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>

                {dispSupplier ? <Row>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      {PY_SUP_DISPLAY ? PY_SUP_DISPLAY : "Supplier"}
                    </Label>
                  </Col>

                  <Col sm={12} md={3} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strSupplier}
                      onChange={Gen_Vendor_OnChange}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>

                  <Col sm={12} md={5} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strSupplierName}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>

                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tog_xlarge_supplier}
                      disabled={Disabled ? true : disableTransBTN ? true : Gen_Vendor_Enabled}
                      color="success"
                      className="btn-sm"
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>

                </Row> : null}

                {dispCustomer ? <Row>

                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      {PY_CUS_DISPLAY ? PY_CUS_DISPLAY : "Customer"}
                    </Label>
                  </Col>

                  <Col sm={12} md={3} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strCustomer}
                      onChange={Gen_Customer_OnChange}
                      disabled={true}
                      onBlur={Gen_Customer_onBlur}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>

                  <Col sm={12} md={5} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strCustomerName}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>

                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tog_xlarge_customer}
                      disabled={Disabled ? true : disableTransBTN ? true : Gen_Customer_Enabled}
                      color="success"
                      className="btn-sm"
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>

                </Row> : null}


                {dispMode ? <Row>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      Mode{" "}
                    </Label>
                  </Col>

                  <Col sm={12} md={3} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strMode}
                      onChange={Gen_Location_OnChange}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>
                  <Col sm={12} md={5} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strModeName}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tog_xlarge_mode}
                      disabled={Disabled ? true : disableTransBTN ? true : Gen_Mod_Enabled}
                      color="success"
                      className="btn-sm"
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row> : null}


                <Row>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      Location{" "}
                    </Label>
                  </Col>

                  <Col sm={12} md={3} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strLocation}
                      onChange={Gen_Location_OnChange}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>
                  <Col sm={12} md={5} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strLocationName}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tog_xlarge_location}
                      disabled={Disabled ? true : disableTransBTN ? true : Gen_Location_Enabled}
                      color="success"
                      className="btn-sm"
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>


                <Row>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      Remarks{" "}
                    </Label>
                  </Col>

                  <Col sm={12} md={8} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={Gen_Remark1}
                      onChange={Gen_Remark1_OnChange}
                      disabled={Disabled ? true : Gen_Remark1_Enabled}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>

                </Row>
                <Row>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      Remarks 2
                    </Label>
                  </Col>
                  <Col sm={12} md={8} className="mb-4-sm">
                    <DPDropDown
                      rowClass="mb-4-sm"
                      labelText={"Remarks 2"}
                      optionGroup={ReasonTypes}
                      selectedGroup={strRemarks2}
                      onChange={RemarksOnchange}
                      disabled={Disabled}
                      id={"txtRemarks2"}
                      onKeyPress={e => {
                        KeyPressEvnt(e)
                      }}
                      iconShow={true}
                      labelHide={true}
                    />
                  </Col>

                </Row>

                <Row>
                  <Col></Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>
              </Col>
              <Col sm={12} md={6} className="mb-4-sm">
                <Row>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      Date{" "}
                    </Label>
                  </Col>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="date"
                      value={Gen_TxnDate}
                      onChange={Gen_TxnDate_OnChange}
                      disabled={Disabled ? true : Gen_TxnDate_Enabled}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>


                </Row>

                {dispSalesExec ? <Row>
                  <Col sm={12} md={3} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      {PY_SA_DISPLAY ? PY_SA_DISPLAY : "Collector"}
                    </Label>
                  </Col>

                  <Col sm={12} md={3} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strSalesExec}
                      onChange={Gen_Collector_OnChange}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>
                  <Col sm={12} md={5} className="mb-4-sm">
                    <DPTextBoxforgrid
                      rowClass="mb-4-sm"
                      textType="text"
                      value={strSalesExecName}
                      disabled={true}
                      LableClass="col-md-4 col-form-label-sm"
                      TextBoxClass="col-md-8"
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tog_xlarge_saleExec}
                      disabled={Disabled ? true : disableTransBTN ? true : Gen_SaAssis_Enabled}
                      color="success"
                      className="btn-sm"
                      size="sm"
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row> : null}
                <Row>

                  <Col sm={12} md={3} className="mb-4-sm">
                    <Button
                      color="primary"
                      className="btn-sm"
                      onClick={Gen_LoadInvoices}
                      size="sm"
                      disabled={Disabled ? true : advancePayment ? true : disableTransBTN}
                    >
                      Load Transactions
                    </Button>
                  </Col>
                  <Col sm={12} md={5} className="mb-4-sm">
                    <Button

                      color="primary"
                      className="btn-sm"
                      disabled={ProcessDisable ? true : advancePayment ? true : TotalPayValue > 0 ? false : true}
                      onClick={e => {
                        AutoAllocate()
                      }}
                      size="sm"
                    >
                      Auto Allocate payment(FIFO)
                    </Button>
                  </Col>

                </Row>

                {/* <Row>
                  <Col sm={12} md={4} className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-12 col-form-label-sm"
                    >
                      Method of Detail Listing{" "}
                    </Label>
                  </Col>
                </Row> */}

                {/* <Row>

                  <Col sm={12} md={10} className="mb-4-sm">
                    <div class="d-flex justify-content-between">
                      <input type="radio" value="Graterthan0" name="DeListing" onChange={handleChange} checked={CheckStatus === "Graterthan0"} disabled={Gen_OrderStatus_Enabled} />
                      <label style={{ fontSize: 11 }}>Due Amount grater than 0</label>
                      <input type="radio" value="Lessthan0" name="DeListing" onChange={handleChange} checked={CheckStatus === "Lessthan0"} disabled={Gen_OrderStatus_Enabled} />
                      <label style={{ fontSize: 11 }}>Due Amount Less than 0</label>
                      <input type="radio" value="Zero" name="DeListing" onChange={handleChange} checked={CheckStatus === "Zero"} disabled={Gen_OrderStatus_Enabled} />
                      <label style={{ fontSize: 11 }}>All</label>
                    </div>
                  </Col>
                </Row> */}

              </Col>
            </Row>

            <Row>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
            </Row>
          </CardText>
        </Col>


        <DPSearchBoxDynamic
          searchData={[]}
          columns={[]}
          defaultSorted={defaultSortedCus}
          mainTitle={`${menuName} Search`}
          SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpen}
          toggle={Gen_DataSearch}
          getSelect={SearchGetSelectRow1}
          APIURL={ApiURL}
          URLPath={Type}
          MenuCode={menuCode}
          orderBy={"DESC"}
          KeyVal={"PAY"}
          searchBy={"HED_RUNNO"}
          FilterStr={` AND HED_SETUPLOC = '${LocationCode}'`}
        />


        <DPSearchBoxDynamic
          searchData={[]}
          columns={[]}
          defaultSorted={defaultSortedCus}
          mainTitle={PY_SUP_DISPLAY + " Search"}
          SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_supplier}
          toggle={tog_xlarge_supplier}
          getSelect={SearchGetSelectRowSupplier}
          APIURL={ApiURL}
          URLPath={"SUPPLIER"}
          MenuCode={menuCode}
          KeyVal={"SUP"}
          searchBy={PY_SUP_SEARCH}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={[]}
          columns={[]}
          defaultSorted={defaultSortedCus}
          mainTitle={PY_CUS_DISPLAY + " Search"}
          SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_customer}
          toggle={tog_xlarge_customer}
          getSelect={SearchGetSelectRowCustomer}
          APIURL={ApiURL}
          URLPath={"CUSTOMER"}
          MenuCode={menuCode}
          KeyVal={"CUS"}
          searchBy={PY_CUS_SEARCH}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={[]}
          columns={[]}
          defaultSorted={defaultSortedCus}
          mainTitle={PY_SA_DISPLAY + " Search"}
          SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_saleExec}
          toggle={tog_xlarge_saleExec}
          getSelect={SearchGetSelectRowSalesExec}
          APIURL={ApiURL}
          URLPath={"SALEEXEC"}
          MenuCode={menuCode}
          KeyVal={"SAE"}
          searchBy={PY_SA_SEARCH}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={[]}
          columns={[]}
          defaultSorted={defaultSortedCus}
          mainTitle={"Location Search"}
          SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_location}
          toggle={tog_xlarge_location}
          getSelect={SearchGetSelectRowLocation}
          APIURL={ApiURL}
          URLPath={"LOCATION"}
          MenuCode={menuCode}
          KeyVal={"LOC"}
          searchBy={"LOC_CODE"}
          FilterStr={` AND LOC_CODE = '${LocationCode}'`}
        />

        <DPSearchBoxDynamic
          searchData={[]}
          columns={[]}
          defaultSorted={defaultSortedCus}
          mainTitle={"Mode Search"}
          SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_mode}
          toggle={tog_xlarge_mode}
          getSelect={GetSelectRowMode}
          APIURL={ApiURL}
          URLPath={"MODE"}
          MenuCode={menuCode}
          KeyVal={"MOD"}
          searchBy={"RW_CODE"}
          FilterStr={groupFilter}
        />

      </div>
    </React.Fragment>
  )
}
export default CreditNoteContent
